<script setup lang="ts">
import { normalizeDownloadLinks, type AppDownloadLinksResponse } from '~/api/download'

const { t } = useAppI18n()
interface DownloadItem {
  key: 'app-store' | 'google-play' | 'android-apk'
  title: string
  href: string
  icon: string
}

const props = defineProps<{
  downloadLinks?: AppDownloadLinksResponse | null
}>()

const downloadList: [Omit<DownloadItem, 'href'>, Omit<DownloadItem, 'href'>, Omit<DownloadItem, 'href'>] = [
  {
    key: 'app-store',
    title: 'App Store',
    icon: 'https://resources1.interface003.com/web30/2026/06/15/c535f9c7-15f0-4023-802a-03ff2ea08a6a.png',
  },
  {
    key: 'google-play',
    title: 'Google Play',
    icon: 'https://resources1.interface003.com/web30/2026/06/15/71a74c98-7d8a-4b0b-9bd0-9421e4ebbfaf.png',
  },
  {
    key: 'android-apk',
    title: 'Android APK',
    icon: 'https://resources1.interface003.com/web30/2026/06/15/0bad9a50-e1db-4d8e-a7f1-7453a77c5df0.png',
  },
]

/** 父组件传入的下载地址在这里统一做兜底，子组件只负责渲染。 */
const resolvedDownloadLinks = computed<AppDownloadLinksResponse>(() =>
  normalizeDownloadLinks(props.downloadLinks ?? null),
)

const downloadItems = computed<DownloadItem[]>(() => [
  {
    ...downloadList[0],
    href: resolvedDownloadLinks.value.appStoreUrl,
  },
  {
    ...downloadList[1],
    href: resolvedDownloadLinks.value.googlePlayUrl,
  },
  {
    ...downloadList[2],
    href: resolvedDownloadLinks.value.androidApkUrl,
  },
])
</script>

<template>
  <section
    class="flex w-full min-w-[384px] flex-col gap-[24px] rounded-[12px] bg-[#E9F2FF] p-[24px]"
    aria-label="Download WikiBit APP"
  >
    <div class="flex flex-col gap-[4px]">
      <p class="text-[16px] leading-[24px] font-[400] text-[#505258]">
        {{ t('82524') }}
      </p>
      <h2 class="text-[20px] leading-[28px] font-[600] text-[#292A2E]">
        {{ t('82496') }}
      </h2>
    </div>

    <div class="flex flex-col gap-[12px]">
      <a
        v-for="item in downloadItems"
        :key="item.key"
        :href="item.href"
        target="_blank"
        rel="noopener noreferrer"
        class="flex w-full items-center gap-[12px] rounded-[8px] bg-white px-[16px] py-[8px] transition-transform duration-200 hover:translate-y-[-1px] hover:bg-[rgba(0,0,0,0.03)]"
      >
        <div class="flex size-[28px] shrink-0 items-center justify-center overflow-hidden">
          <CommonImage
            :src="item.icon"
            alt="Download on the {{ item.title }}"
            class="size-full object-cover"
            loading="eager"
          />
        </div>

        <div class="flex min-w-[0px] flex-1 flex-col text-[#090909]">
          <span class="text-[11px] leading-[16px] font-[400]"> Download on the </span>
          <span class="text-[16px] leading-[24px] font-[600]">
            {{ item.title }}
          </span>
        </div>

        <CommonImage
          class="size-[20px]"
          src="https://resources1.interface003.com/web30/2026/06/15/1325cb8f-510e-4899-937d-d8c722791871.png"
          alt="arrow right"
          loading="eager"
        />
      </a>
    </div>
  </section>
</template>
